import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ShiftDataService } from '../shift-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { chain } from 'lodash';

@Component({
  selector: 'app-chainage-filter-dialog',
  templateUrl: './chainage-filter-dialog.component.html',
  styleUrls: ['./chainage-filter-dialog.component.scss']
})
export class ChainageFilterDialogComponent implements OnInit {

  chainageValues : any;
  selectedChaingeVal :any ;
  fromValue :any ;
  toValue :any ;
  defaultMinChainage:any;
  defaultMaxChainage:any;
  minError :boolean = false;
  maxError :boolean = false;
  index:number = 0;

  constructor(public shiftDataService :ShiftDataService,
    private route: ActivatedRoute,
    private _router: Router,
    public dialogRef: MatDialogRef<ChainageFilterDialogComponent>) {
      let ranges :any = localStorage.getItem('selectedChainageRanges')
      let realValues :any = localStorage.getItem("OriginalChainageValues");
      this.chainageValues = [...this.shiftDataService.chainageValues];
    if(ranges && ranges != "[]" && ranges != null && ranges!= undefined && ranges != '' && ranges.length > 0){
      let selectedChainageRanges = JSON.parse(ranges);
      this.shiftDataService.selectedChainageRanges = selectedChainageRanges;
      if(selectedChainageRanges && selectedChainageRanges[0]){
        this.selectedChaingeVal = selectedChainageRanges[0];
        this.fromValue = selectedChainageRanges[0].chainage[0];
        this.toValue = selectedChainageRanges[0].chainage[1];
        this.defaultMinChainage = selectedChainageRanges[0].chainage[0];
        this.defaultMaxChainage = selectedChainageRanges[0].chainage[1];
      }
      else if(selectedChainageRanges){
        this.selectedChaingeVal = selectedChainageRanges;
        this.fromValue = selectedChainageRanges.chainage[0];
        this.toValue = selectedChainageRanges.chainage[1];
        this.defaultMinChainage = selectedChainageRanges.chainage[0];
        this.defaultMaxChainage = selectedChainageRanges.chainage[1];
      }
      this.chainageValues.forEach((val,index)=>{
        this.isChecked(index);
      })
    }
    else{
      if(realValues && realValues != null && realValues!= undefined && realValues != '' && realValues.length > 0){
        let selectedChainageRanges = JSON.parse(realValues);
        this.shiftDataService.selectedChainageRanges = [];
        this.selectedChaingeVal =selectedChainageRanges[0];
        this.fromValue = selectedChainageRanges[0].chainage[0];
        this.toValue = selectedChainageRanges[0].chainage[1];
        this.defaultMinChainage = selectedChainageRanges[0].chainage[0];
        this.defaultMaxChainage = selectedChainageRanges[0].chainage[1];
        this.shiftDataService.chainageValues[1].chainage[0] = selectedChainageRanges[1].chainage[0];
        this.shiftDataService.chainageValues[1].chainage[1] = selectedChainageRanges[1].chainage[1];
        this.chainageValues.forEach((val,index)=>{
          this.isChecked(index);
        })
    }
    }
     }

  ngOnInit(): void {
  }

  onChainageValueClick(chainage,i:number){
    if(!this.minError && !this.maxError){
    this.selectedChaingeVal.chainage[0] = this.minError  ? this.selectedChaingeVal.chainage[0] : this.fromValue;
    this.selectedChaingeVal.chainage[1] = this.maxError  ? this.selectedChaingeVal.chainage[1] : this.toValue;
    this.selectedChaingeVal = chainage;
    this.fromValue = this.selectedChaingeVal.chainage[0];
    this.toValue = this.selectedChaingeVal.chainage[1];
    this.defaultMinChainage = this.shiftDataService.chainageValues[i].chainage[0];
    this.defaultMaxChainage = this.shiftDataService.chainageValues[i].chainage[1];
    this.minError = false;
    this.maxError = false;
    this.index = i;
    }
  }

  minValueChange(minVal : any){
    let realValues :any = localStorage.getItem("OriginalChainageValues");
    if(realValues && realValues != null && realValues!= undefined && realValues != '' && realValues.length > 0){
      let selectedChainageRanges = JSON.parse(realValues);   
    this.minError = (minVal == '' || parseInt(minVal) >  selectedChainageRanges[this.index].chainage[1] || parseInt(minVal) <  selectedChainageRanges[this.index].chainage[0]
     || parseInt(minVal) > this.toValue)? true : false;
    this.fromValue = minVal;
    this.selectedChaingeVal.chainage[0] = this.fromValue;
    this.isChecked(this.index);
  }
  }  
  
  maxValueChange(maxVal : any){
    let realValues :any = localStorage.getItem("OriginalChainageValues");
    if(realValues && realValues != null && realValues!= undefined && realValues != '' && realValues.length > 0){
      let selectedChainageRanges = JSON.parse(realValues);
    this.maxError = (maxVal == '' || parseInt(maxVal) > selectedChainageRanges[this.index].chainage[1] || parseInt(maxVal) < selectedChainageRanges[this.index].chainage[0]
     || parseInt(maxVal) < this.fromValue)? true : false;
    this.toValue = maxVal;
    this.selectedChaingeVal.chainage[1] = this.toValue;
    this.isChecked(this.index);
    }
  }

  onChainageFilterClick() {
    if(!this.minError && !this.maxError){
      if(this.toValue<this.fromValue ||
        this.toValue>this.selectedChaingeVal.chainage[1] ||
        this.fromValue>this.selectedChaingeVal.chainage[1]||
        this.fromValue<this.selectedChaingeVal.chainage[0]){}
    else{
      this.shiftDataService.applyRangeChainageFilters(
        this.shiftDataService.selectedChainageRanges
      );
      localStorage.setItem('selectedChainageRanges',JSON.stringify(this.shiftDataService.selectedChainageRanges));
      this.dialogRef.close();
    }   
  }
  }

  selecteChainageRange(chainage :any ,index:number){
    if(!this.minError && !this.maxError){
        this.shiftDataService.selectedChainageRanges =
        this.shiftDataService && this.shiftDataService.selectedChainageRanges 
        && this.shiftDataService.selectedChainageRanges.filter(
            (a) => +a.index == +chainage.index
        ).length > 0
            ? this.shiftDataService.selectedChainageRanges.filter(
                  (a) => +a.index != +chainage.index
              )
            : [...this.shiftDataService.selectedChainageRanges, chainage];
    this.onChainageValueClick(chainage,index);
            }
  }

  assignValues(chainage :any ,index:number):any{
    this.shiftDataService.selectedChainageRanges.values.push(chainage);
  }
  assignIndexValues(chainage :any ,index:number):any{
    this.shiftDataService.selectedChainageRanges.values.push(chainage);
    this.shiftDataService.selectedChainageRanges.index.push(index);
  }

  removeIndexValue(index : any){
    this.shiftDataService.selectedChainageRanges.index =
    this.shiftDataService.selectedChainageRanges.index.filter(
      (range) => !range.includes(index)
    )
  }

  isChecked(index: any) {
    let ranges = localStorage.getItem('selectedChainageRanges')
    if(ranges && ranges != null && ranges!= undefined && ranges != ''){
      let selectedChainageRanges = JSON.parse(ranges);
      if(selectedChainageRanges){
        return (selectedChainageRanges.filter((a) => a.index == index)).length > 0 ? true : false;
      }
  }
  }
  isFilterEnabled(){
    return (!this.minError && !this.maxError && this.shiftDataService.selectedChainageRanges.length > 0)? true: false;
  }
  closeDialogBox(){
    this.dialogRef.close();
  }
}
